module.exports = __webpack_public_path__ + "static/media/chevron-down-solid.537c190f.svg";